module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp1_7005.82c75c80.png";